import React, { useEffect } from 'react';

import { FullScreenLoader } from 'components/FullScreenLoader';
import queryString from 'query-string';
import { useLocation } from 'react-router';

export function GoogleDriveAuthPopupRedirect() {
  const location = useLocation();
  const { code } = queryString.parse(location.search);

  useEffect(() => {
    if (!code || typeof code !== 'string') return;
    window.opener.postMessage({ authCode: code }, window.location.origin);
    window.close();
  }, []);

  return <FullScreenLoader />;
}
